import { createAction } from 'redux-actions'
import { LOGIN_USER, LOGOUT_USER, SET_HIGH_CONTRAST, GET_ZONES, LOGIN_USER_ERROR, GET_CONFIG,
         API_ERROR, MFA_REQUIRED, MFA_ERROR, MFA_INFO, MFA_CANCEL } from '../constants/ActionTypes'
import { loadTranslations } from './RmaActions'
import Odoo from '../utils/Odoo'

export const logUserOut = createAction(LOGOUT_USER)
export const cancelMfa = createAction(MFA_CANCEL)

export function setHighContrast(high_contrast) {
  return dispatch => {
    dispatch({
      type: SET_HIGH_CONTRAST,
      payload: high_contrast
    })
  }
}

export function getZones(){
  return dispatch => {
    let params = {}
    Odoo.login('rma/get_zones', params, false).then(zones => {
      dispatch({
        type: GET_ZONES,
        payload: zones
      })
    }).catch(error => {
      dispatch({
        type: API_ERROR,
        message: error.message
      })
    })
  }
}

// Shared tail of both login paths: the credentials one and the MFA one.
function openSession(dispatch, session) {
  Odoo.call('rma/get_config', {}, session.token).then(config => {
    dispatch({
      type: GET_CONFIG,
      payload: { ...config }
    })
    dispatch({
      type: LOGIN_USER,
      payload: { ...session }
    })
    dispatch(loadTranslations((session.lang==='pl_PL') ? 'pl-PL' : 'en-US'))
  }).catch(error => {
    dispatch({
      type: API_ERROR,
      message: error.message
    })
  })
}

export function logUserIn(login, password, rma_zone, rma_zone_password) {
  return dispatch => {
    let params = {login, password, rma_zone, rma_zone_password}
    Odoo.login('rma/login', params).then(session => {
      if (session.mfa_required) {
        dispatch({
          type: MFA_REQUIRED,
          payload: { ...session }
        })
        return
      }
      openSession(dispatch, session)
    }).catch(error => {
      dispatch({
        type: LOGIN_USER_ERROR,
        message: error.message
      })
    })
  }
}

export function verifyMfaCode(mfa_token, code) {
  return dispatch => {
    Odoo.login('mfa/verify', {mfa_token, code}).then(session => {
      openSession(dispatch, session)
    }).catch(error => {
      dispatch({
        type: MFA_ERROR,
        message: error.message
      })
    })
  }
}

export function resendMfaCode(mfa_token) {
  return dispatch => {
    Odoo.login('mfa/resend', {mfa_token}).then(message => {
      dispatch({
        type: MFA_INFO,
        message: message
      })
    }).catch(error => {
      dispatch({
        type: MFA_ERROR,
        message: error.message
      })
    })
  }
}
